import { MRT_ColumnDef, MRT_PaginationState } from "material-react-table";
import { useState } from "react";
import { Alert, Box, Button, Chip, IconButton, MenuItem, Select, Snackbar, Typography } from "@mui/material";
import { Delete, Edit, RemoveRedEye } from "@mui/icons-material";
import { useNavigate } from "react-router-dom";
import { DataTable } from "../../libs/core/components/data-table";
import { ConfirmModal } from "../../libs/ui/modal/confirm_modal";
import { useGetScheduledVisitsQuery, useUpdateStatusMutation } from "./api/scheduledVisitApi";
import { Visit } from "./types/visit";

const ScheduleVisitManager: React.FC = () => {
  const [pagination, setPagination] = useState<MRT_PaginationState>({
    pageIndex: 0,
    pageSize: 10,
  });

  const [openDialog, setOpenDialog] = useState(false);
  const [openConfirmModal, setOpenConfirmModal] = useState(false);
  const [selectedVisit, setSelectedVisit] = useState<Visit | null>(null);
  const navigate = useNavigate();

  const { data: visits, isLoading, isError, isFetching } = useGetScheduledVisitsQuery();

  const columns: Array<MRT_ColumnDef<Visit>> = [
    {
      header: "Full Name",
      accessorFn: (row) => `${row.visitor_first_name} ${row.visitor_last_name}`,
      size: 150,
    },
    { header: "Phone", accessorKey: "visitor_phone", size: 120 },
    { header: "Email", accessorKey: "visitor_email", size: 200 },
    { header: "Scheduled Date", accessorKey: "scheduled_at", size: 180 },
    // { header: "Status", accessorKey: "status", size: 100 },
    {
      header: "Status",
      accessorKey: "status",
      size: 120,
      Cell: ({ row }) => {
        const [updateStatus] = useUpdateStatusMutation();
        const visit = row.original;
    
        const handleChange = async (event: any) => {
          const newStatus = event.target.value;
          try {
            await updateStatus({ id: visit.id, body: {status: newStatus}  }).unwrap();
          } catch (error) {
            console.error("Failed to update status", error);
          }
        };
    
        return (
          <Select
            value={visit.status}
            onClick={(e) => e.stopPropagation()}
            onChange={handleChange}
            size="small"
            sx={{ minWidth: 120 }}
          >
            <MenuItem value="pending">Pending</MenuItem>
            <MenuItem value="confirmed">Confirmed</MenuItem>d
            <MenuItem value="cancelled">Cancelled</MenuItem>
          </Select>
        );
      },
    },
    
    // { header: "Note", accessorKey: "note", size: 200 },

  ];

  return (
    <Box>
      <DataTable<Visit>
        toolbar={
          <Box display="flex" alignItems="center" width="100%">
            <Box display="flex" gap={3} alignItems="center" flex="1">
              <Typography variant="h6">Scheduled Visits</Typography>
              <Chip
                color="primary"
                variant="outlined"
                label={`${visits?.data?.length ?? 0} Visits`}
              />
            </Box>
          </Box>
        }
        list={visits?.data ?? []}
        count={visits?.data?.length ?? 0}
        columns={columns}
        getRowId={(row) => row?.id?.toString()}
        isLoading={isLoading}
        isSuccess={!isError}
        isError={isError}
        isFetching={isFetching}
        renderRowActions={(row) => (
          <Box display={"flex"} gap={1}>
            {/* <IconButton
              onClick={(e) => {
                e.stopPropagation();
                setSelectedVisit(row);
                setOpenConfirmModal(true);
              }}
            >
              <Delete />
            </IconButton> */}
            {/* <IconButton
              onClick={(e) => {
                e.stopPropagation();
                setSelectedVisit(row);
                setOpenDialog(true);
              }}
            >
              <Edit />
            </IconButton> */}
            <IconButton
              onClick={(e) => {
                e.stopPropagation();
                navigate(`/scheduled-visits/${row.id}`);
              }}
            >
              <RemoveRedEye />
            </IconButton>
          </Box>
        )}
        pagination={pagination}
        onPaginationChange={setPagination}
        onRowClick={(row) => navigate(`/scheduled-visits/${row.id}`)}
      />
    </Box>
  );
};

export default ScheduleVisitManager;
